import React, { useState } from "react";
import { motion } from "framer-motion";
import { User, Gift, MapPin, Package, Star } from "lucide-react";
import { useSettings } from "../context/SettingsContext";
// Import tab components
import ProfileTab from "../components/account/ProfileTab";
import RewardsTab from "../components/account/RewardsTab";
import OrderList from "../components/account/OrdersTab"; // ✅ updated (new trimmed version below)
import AddressesTab from "../components/account/AddressesTab";
import GiftVouchersTab from "../components/account/GiftVouchersTab";

const TABS = [
  { id: "profile", label: "My Profile", icon: User },
  { id: "rewards", label: "My Rewards", icon: Star },
  { id: "orders", label: "My Orders", icon: Package },
  { id: "addresses", label: "Addresses", icon: MapPin },
  { id: "giftvouchers", label: "My Gift Vouchers", icon: Gift },
];

const MyAccount = () => {
  const [activeTab, setActiveTab] = useState("profile");
const { settings } = useSettings();
  const renderTabContent = () => {
    switch (activeTab) {
      case "profile":
        return <ProfileTab />;
      case "rewards":
        return <RewardsTab />;
      case "orders":
        return <OrderList />; // ✅ Now this is a nested component, not full page
      case "addresses":
        return <AddressesTab />;
      case "giftvouchers":
        return <GiftVouchersTab />;
      default:
        return <ProfileTab />;
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-amber-50 to-white py-10 px-6 sm:px-10">
      <div className="max-w-6xl mx-auto bg-white rounded-2xl shadow-xl overflow-hidden border border-amber-100">
        {/* Header */}
        <div className="border-b border-gray-200 p-6 bg-gradient-to-r from-amber-100 to-amber-50">
          <h1 className="text-3xl font-extrabold text-amber-800 text-center"  style={{ color: settings?.cart_btn_color || "#111827" }}>
            My Account
          </h1>
          <p className="text-gray-600 text-sm mt-1 text-center">
            Manage your personal details, orders, and rewards
          </p>
        </div>

        {/* Tab Buttons */}
        <div className="flex flex-wrap justify-center gap-2 sm:gap-4 border-b border-gray-200 bg-white px-4 py-4">
          {TABS.map(({ id, label, icon: Icon }) => {
            const isActive = activeTab === id;
            return (
              <motion.button
                key={id}
                onClick={() => setActiveTab(id)}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.97 }}

                 style={{
  background: isActive && settings?.cart_btn_color || "#ffffff",
   color: isActive && settings?.cart_btn_text_color || "#000000ff",
}}
onMouseEnter={(e) => {
  e.currentTarget.style.background =
   isActive && settings?.cart_btn_hover || "#ffffff";
}}
onMouseLeave={(e) => {
  e.currentTarget.style.background =
   isActive && settings?.cart_btn_color || "#ffffff";
}}
                className={`flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium transition-all border ${
                  isActive
                    ? "bg-amber-600 text-white border-amber-600 shadow-md"
                    : "bg-white text-gray-700 border-gray-200 hover:border-amber-400 hover:text-amber-700"
                }`}
              >
                <Icon
                  className={`w-4 h-4 ${
                    isActive ? "text-white" : "text-amber-600"
                  }`}
                />
                <span>{label}</span>
              </motion.button>
            );
          })}
        </div>

        {/* Content */}
        <motion.div
          key={activeTab}
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3 }}
          className="p-6"
        >
          {renderTabContent()}
        </motion.div>
      </div>
    </div>
  );
};

export default MyAccount;
